import React, { useState } from 'react';
import { Button, Container, Grid, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { useCategories } from '../../hooks/token-manager';
import { useGetTraits, useTrait } from '../../hooks/traits-hooks';
import SimpleDropdown from './SimpleDropdown';

const CreateNewCategory = () => {
  const [ categoryName, setCategoryName ] = useState('');

  const { createCategory } = useCategories();

  return (
    <Container>
      <Typography variant='h5'>
        Create a new category
      </Typography>
      <TextField
        onChange={ (e) => {
          setCategoryName(e.target.value);
        } }
        value={ categoryName }
      />
      <Button onClick={ () => {
        return createCategory({ name: categoryName });
      } }
      >
        Create new Category
      </Button>
    </Container>
  );
};

const TraitCategory = () => {
  const [ selectedTraitId, setSelectedTraitId ] = useState(null);
  const [ selectedCategoryId, setSelectedCategoryId ] = useState(null);

  const {
    traits,
    traitsLoading,
  } = useGetTraits();

  const {
    categories,
    categoriesLoading,
  } = useCategories();

  const {
    createTraitCategory,
  } = useTrait(selectedTraitId);

  if (traitsLoading || categoriesLoading) {
    return <p>Loading</p>;
  }

  return (
    <Grid container spacing={ 8 }>
      <Grid container item xs={ 12 } spacing={ 3 }>
        <CreateNewCategory />
      </Grid>

      <Grid container item xs={ 12 } spacing={ 3 }>
        <Grid item xs={ 4 }>
          <SimpleDropdown
            label='Select a trait'
            value={ selectedTraitId }
            onChange={ (v) => {
              setSelectedTraitId(v);
            } }
            options={ traits }
            optionDisplay={ (trait) => { return `${ trait.name } <${ trait.id }>`; } }
          />
        </Grid>

        <Grid item xs={ 4 }>
          <SimpleDropdown
            label='Select a category'
            value={ selectedCategoryId }
            onChange={ (v) => {
              setSelectedCategoryId(v);
            } }
            options={ categories }
            optionDisplay={ (category) => { return `${ category.name } <${ category.id }>`; } }
          />
        </Grid>
        <Grid item xs={ 4 }>
          <Button
            disabled={ !selectedTraitId || !selectedCategoryId }
            onClick={ () => {
              return createTraitCategory({ categoryId: selectedCategoryId });
            } }
          >
            Add category to trait
          </Button>
        </Grid>
      </Grid>

    </Grid>
  );
};

export default TraitCategory;
